export var getLoginBaseURL = function getLoginBaseURL() {
  return "https://".concat(process.env.FINECT_LOGIN_BASEURL);
};
export var getBaseURL = function getBaseURL() {
  return "https://".concat(process.env.FINECT_BASEURL || 'www.finect.com');
};
export var getSuperPartnerBaseURL = function getSuperPartnerBaseURL() {
  return "https://".concat(process.env.FINECT_SUPERPARTNER_BASEURL || process.env.FINECT_BASEURL || 'www.finect.com');
};